import { List } from 'immutable';
import { TypedMap } from 'flow/types/TypedMap';
import { ChatMember, ChatSession, SortInfo } from 'flow/types/Chats';

export const roomTypes = {
    session: 'session',
    room: 'room',
    public: 'public',
    external: 'external',
};

interface Attachment {
    name: string;
    file: File;
}

export const isNumberSMSChat = (
    attachment: Attachment,
    session: TypedMap<SortInfo>,
) => {
    if (attachment || !session) {
        return false;
    }
    const member = session
        .get('members', List())
        .filter((member: TypedMap<ChatMember>) => !member.get('contact'));

    return member.some((member: TypedMap<ChatMember>) =>
        member.has('mobileNumber'),
    );
};

export const isDirectMessageSession = (session: TypedMap<ChatSession>) => {
    return (
        session?.get('roomType') === 'session' &&
        session?.get('members')?.size === 2 &&
        session
            ?.get('members')
            ?.find((member) => !!member.get('mobileNumber')) === undefined
    );
};

export const isNotDirectMessageSession = (session: TypedMap<ChatSession>) => {
    return !isDirectMessageSession(session);
};
